import { inject as a, useId as I, computed as s, provide as $, openBlock as E, createElementBlock as x, normalizeClass as l, createElementVNode as o, unref as e, renderSlot as m, toDisplayString as y, createVNode as p, Transition as C, withCtx as D, withDirectives as A, vShow as j } from "vue";
import S from "../../atoms/icon-core/icon-core.vue.js";
import { useTracking as B } from "../../composables/useTracking.js";
import { useTransitionExpand as L } from "../../composables/useTransitionExpand.js";
/* empty css                    */
const N = ["id", "aria-controls", "aria-expanded", "data-track-component-name", "data-track-text"], T = ["id", "aria-labelledby"], O = { class: "ds-padding-bottom-24" }, V = /* @__PURE__ */ Object.assign({
  name: "DsAccordionItem"
}, {
  __name: "accordion-item",
  props: {
    title: { type: String, default: "" },
    opened: { type: Boolean, default: !1 }
  },
  setup(i) {
    const { enter: u, afterEnter: v, leave: h } = L(), { trackingDataProvided: f } = B(), k = a("setActiveItem", () => {
    }), b = a("onItemClicked", () => {
    }), d = a("theme", "light"), g = a("activeItem", ""), r = i, t = I();
    r.opened && k(t);
    const n = s(() => g.value === t), _ = s(() => `ds-accordion-item--${d}`), w = () => {
      b(n.value ? "close" : "open", r.title, t);
    };
    return $("trackingData", { "component-name": "DsAccordionItem", title: r.title }), (c, z) => (E(), x("div", {
      class: l(["ds-accordion-item", _.value])
    }, [
      o("h3", null, [
        o("button", {
          id: `accordion-header-${e(t)}`,
          "aria-controls": `accordion-panel-${e(t)}`,
          type: "button",
          "aria-haspopup": "true",
          "aria-expanded": n.value,
          class: l([[
            { "ds-button-link-dropdown--active": n.value },
            { "ds-button-link-dropdown--black": e(d) === "light" },
            { "ds-button-link-dropdown--white": e(d) === "dark" }
          ], "ds-button-link-dropdown ds-accordion-item__header ds-text ds-font-weight-bold"]),
          "data-j-header": "",
          "data-track-component-name": e(f)["component-name"] || c.$options.name,
          "data-track-text": i.title,
          onClick: w
        }, [
          m(c.$slots, "title", {}, () => [
            o("span", null, y(i.title), 1)
          ]),
          p(S, {
            category: "arrows",
            name: "chevron-down"
          })
        ], 10, N)
      ]),
      p(C, {
        name: "ds-expand",
        onEnter: e(u),
        onAfterEnter: e(v),
        onLeave: e(h)
      }, {
        default: D(() => [
          A(o("div", {
            id: `accordion-panel-${e(t)}`,
            "aria-labelledby": `accordion-header-${e(t)}`,
            class: "ds-accordion-item__panel",
            role: "region",
            "data-j-panel": ""
          }, [
            o("div", O, [
              m(c.$slots, "default")
            ])
          ], 8, T), [
            [j, n.value]
          ])
        ]),
        _: 3
      }, 8, ["onEnter", "onAfterEnter", "onLeave"])
    ], 2));
  }
}), J = V;
export {
  J as default
};
